import { createSvgIcon } from '@mui/material';

export default createSvgIcon(
  <path d="m21.6 5.7l-6.3 6.3 6.3 6.3c0.9 0.9 0.9 2.4 0 3.4-0.5 0.5-1.1 0.7-1.7 0.7s-1.2-0.2-1.7-0.7l-6.3-6.3-6.3 6.3c-0.5 0.5-1.1 0.7-1.7 0.7s-1.2-0.2-1.7-0.7c-0.9-0.9-0.9-2.4 0-3.4l6.4-6.3-6.3-6.3c-0.9-0.9-0.9-2.4 0-3.4 0.9-0.9 2.4-0.9 3.4 0l6.3 6.3 6.3-6.3c0.9-0.9 2.4-0.9 3.4 0 0.8 1 0.8 2.5-0.1 3.4z" />,
  `CrossIcon`
);
